import * as React from "react";

export function SocialIcon({url, children, isLarge = true}) {
    return <a href={url} rel="noopener" target="_blank" className={"icon " + (isLarge ? "is-large": "")}>
        {children}
    </a>
}